import { useState } from 'react';

const useValidation = (schema) => {
  const [errors, setErrors] = useState([]);

  const validate = (data) => {
    const result = schema.safeParse(data);
    if (!result.success) {
      setErrors(result.error.issues);
      return { isValid: false, errors: result.error.issues, error: result.error };
    }
    setErrors([]);
    return { isValid: true, data: result.data, errors: [] };
  };

  return { validate, errors };
};

export default useValidation;
